import { SvgIcon } from '@mui/material';
import {
  mdiFormatListBulleted,
  mdiContentSaveOutline,
  mdiMinusCircleOutline,
} from '@mdi/js';
import React from 'react';

/**
 * ListIcon
 * @param style
 * @param props
 * @constructor
 */
export const ListIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiFormatListBulleted} />
    </SvgIcon>
  );
};

/**
 * SaveIcon
 * @param style
 * @param props
 * @constructor
 */
export const SaveIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiContentSaveOutline} />
    </SvgIcon>
  );
};

/**
 * RemoveIcon - minus in circle for removing items
 * @param style
 * @param props
 * @constructor
 */
export const RemoveIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiMinusCircleOutline} />
    </SvgIcon>
  );
};
